"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStringEnumValues = exports.getStringEnumKeys = exports.getNumberEnumValues = exports.getNumberEnumKeys = void 0;
/**
 * Retrieves all keys of a "pure" number enum as array.
 * It does not work for mixes enums.
 */
const getNumberEnumKeys = (en) => {
    return Object.values(en).filter((v) => typeof v === 'string');
};
exports.getNumberEnumKeys = getNumberEnumKeys;
/**
 * Retrieves all values of a "pure" number enum as array.
 * It does not work for mixes enums.
 */
const getNumberEnumValues = (en) => {
    return Object.values(en).filter((v) => typeof v !== 'string');
};
exports.getNumberEnumValues = getNumberEnumValues;
/**
 * Retrieves all values of a "pure" string enum as array.
 * It does not work for mixes enums.
 */
const getStringEnumKeys = (en) => {
    return Array.from(new Set(Object.keys(en)));
};
exports.getStringEnumKeys = getStringEnumKeys;
/**
 * Retrieves all values of a "pure" string enum as array.
 * It does not work for mixes enums.
 */
const getStringEnumValues = (en) => {
    return Array.from(new Set(Object.values(en)));
};
exports.getStringEnumValues = getStringEnumValues;
//# sourceMappingURL=enumUtils.js.map